import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { FormLockService } from './services/form-lock.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  private formLockService = inject(FormLockService);
  private subscription = new Subscription();

  title = 'forms';
  isLocked = false;

  ngOnInit(): void {
    // Initialize with current lock state
    try {
      this.isLocked = this.formLockService.isLocked();

      // Subscribe to lock state to disable swipe gestures when locked
      this.subscription.add(
        this.formLockService.isLocked$.subscribe((locked) => {
          this.isLocked = locked;
        }),
      );
    } catch (error) {
      console.error('Error initializing form lock service:', error);
      // Continue with unlocked state if service fails
      this.isLocked = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
